module.exports = __webpack_public_path__ + "img/risk.c6bf5aad.png";